<template>
  <div class="pc ecran-public">
    <slot></slot>
  </div>
</template>

<script setup>
/**
 * CARTE D'UN ÉCRAN PUBLIC.
 *
 * La surface blanche sur laquelle un visiteur remplit ou lit quelque chose :
 * un formulaire de devis, une signature, un émargement. Elle porte
 * `.ecran-public`, qui donne au kit sa taille publique (src/styles/public.css)
 * et le teal de la nouvelle interface (src/styles/variables.css) — c'est ce qui
 * fait qu'un écran public n'hérite ni du rouge de la v1 ni des contrôles de
 * 40 px du back-office.
 *
 * Le cadre AUTOUR de la carte (largeur, fond de page, marges d'un embed)
 * appartient à la vue : il change d'un écran à l'autre, pas la carte.
 */
</script>

<style scoped>
.pc {
  background: var(--color-bg-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-8);
}

@media (max-width: 768px) {
  .pc {
    padding: var(--spacing-6) var(--spacing-5);
  }
}
</style>
